// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= PAGE ================= */
.schedule-page,
body {
  background: #020617;
  color: #e5e7eb;
  font-family: system-ui, -apple-system, BlinkMacSystemFont,
    "Segoe UI", sans-serif;
}

/* ================= HEADINGS ================= */
h2 {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 14px;
}

h3 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  color: #cbd5f5;
}

/* ================= GRID LAYOUT ================= */
.schedule-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
  gap: 28px;
  margin-top: 24px;
}

/* ================= CARD ================= */
.schedule-card {
  background: linear-gradient(
    180deg,
    #0f172a 0%,
    #020617 100%
  );
  border-radius: 18px;
  padding: 18px 20px;
  box-shadow:
    0 20px 45px rgba(0, 0, 0, 0.55),
    inset 0 1px 0 rgba(255, 255, 255, 0.03);
  border: 1px solid #1e293b;
}

/* ================= TABLE ================= */
table {
  width: 100%;
  border-collapse: collapse;
  background: transparent;
}

thead {
  background: transparent;
}

th {
  padding: 14px 10px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
  border-bottom: 1px solid #1e293b;
}

td {
  padding: 14px 10px;
  font-size: 14px;
  border-bottom: 1px solid rgba(30, 41, 59, 0.6);
}

/* ❌ Remove hover highlight */
tbody tr:hover {
  background: transparent;
}

/* ================= STATUS ================= */
.status-active {
  color: #22c55e;
  font-weight: 600;
}

.status-paused {
  color: #facc15;
  font-weight: 500;
}

.status-completed {
  color: #94a3b8;
}

/* ================= BUTTONS ================= */
button {
  background: #1e293b;
  color: #e5e7eb;
  border: 1px solid #334155;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background 0.15s ease, border 0.15s ease;
}

button:hover {
  background: #273449;
  border-color: #475569;
}

/* Primary */
button.primary {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  border: none;
}

button.primary:hover {
  background: linear-gradient(135deg, #1d4ed8, #4338ca);
}

/* Secondary */
button.secondary {
  background: #334155;
}

button.secondary:hover {
  background: #475569;
}

/* Danger */
button.danger,
button[style*="red"] {
  background: linear-gradient(135deg, #7f1d1d, #991b1b);
  border: none;
}

button.danger:hover,
button[style*="red"]:hover {
  background: linear-gradient(135deg, #991b1b, #b91c1c);
}

/* ================= MODAL ================= */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.8);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: linear-gradient(
    180deg,
    #0f172a 0%,
    #020617 100%
  );
  padding: 22px;
  border-radius: 18px;
  width: 420px;
  max-width: 95%;
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.7);
  border: 1px solid #1e293b;
}

.modal h2 {
  margin-bottom: 16px;
  font-size: 18px;
}

.modal label {
  display: block;
  margin-top: 12px;
  margin-bottom: 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
}

.modal input,
.modal select {
  width: 100%;
  padding: 9px;
  border-radius: 8px;
  border: 1px solid #334155;
  background: #020617;
  color: #e5e7eb;
  font-size: 14px;
}
/* ================= SMALL INLINE PLACEHOLDER ================= */
.no-schedule-placeholder {
  padding: 10px 0 16px;
  margin: 6px 0 18px;
  text-align: center;
  font-size: 13px;
  color: #94a3b8;
  opacity: 0.85;
}

.modal input:focus,
.modal select:focus {
  outline: none;
  border-color: #3b82f6;
}

/* ================= MODAL ACTIONS ================= */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

/* ================= EMPTY STATE ================= */
.empty {
  opacity: 0.65;
  font-style: italic;
  padding: 10px 0;
}

/* ================= RESPONSIVE ================= */
@media (max-width: 900px) {
  .schedule-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/schedule.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;;EAEE,mBAAmB;EACnB,cAAc;EACd;0BACwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE;;;;GAIC;EACD,mBAAmB;EACnB,kBAAkB;EAClB;;2CAEyC;EACzC,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;;EAEE,qDAAqD;EACrD,YAAY;AACd;;AAEA;;EAEE,qDAAqD;AACvD;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE;;;;GAIC;EACD,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA,iEAAiE;AACjE;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ================= PAGE ================= */\n.schedule-page,\nbody {\n  background: #020617;\n  color: #e5e7eb;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont,\n    \"Segoe UI\", sans-serif;\n}\n\n/* ================= HEADINGS ================= */\nh2 {\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 14px;\n}\n\nh3 {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 12px;\n  color: #cbd5f5;\n}\n\n/* ================= GRID LAYOUT ================= */\n.schedule-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));\n  gap: 28px;\n  margin-top: 24px;\n}\n\n/* ================= CARD ================= */\n.schedule-card {\n  background: linear-gradient(\n    180deg,\n    #0f172a 0%,\n    #020617 100%\n  );\n  border-radius: 18px;\n  padding: 18px 20px;\n  box-shadow:\n    0 20px 45px rgba(0, 0, 0, 0.55),\n    inset 0 1px 0 rgba(255, 255, 255, 0.03);\n  border: 1px solid #1e293b;\n}\n\n/* ================= TABLE ================= */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  background: transparent;\n}\n\nthead {\n  background: transparent;\n}\n\nth {\n  padding: 14px 10px;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #94a3b8;\n  border-bottom: 1px solid #1e293b;\n}\n\ntd {\n  padding: 14px 10px;\n  font-size: 14px;\n  border-bottom: 1px solid rgba(30, 41, 59, 0.6);\n}\n\n/* ❌ Remove hover highlight */\ntbody tr:hover {\n  background: transparent;\n}\n\n/* ================= STATUS ================= */\n.status-active {\n  color: #22c55e;\n  font-weight: 600;\n}\n\n.status-paused {\n  color: #facc15;\n  font-weight: 500;\n}\n\n.status-completed {\n  color: #94a3b8;\n}\n\n/* ================= BUTTONS ================= */\nbutton {\n  background: #1e293b;\n  color: #e5e7eb;\n  border: 1px solid #334155;\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: background 0.15s ease, border 0.15s ease;\n}\n\nbutton:hover {\n  background: #273449;\n  border-color: #475569;\n}\n\n/* Primary */\nbutton.primary {\n  background: linear-gradient(135deg, #2563eb, #4f46e5);\n  border: none;\n}\n\nbutton.primary:hover {\n  background: linear-gradient(135deg, #1d4ed8, #4338ca);\n}\n\n/* Secondary */\nbutton.secondary {\n  background: #334155;\n}\n\nbutton.secondary:hover {\n  background: #475569;\n}\n\n/* Danger */\nbutton.danger,\nbutton[style*=\"red\"] {\n  background: linear-gradient(135deg, #7f1d1d, #991b1b);\n  border: none;\n}\n\nbutton.danger:hover,\nbutton[style*=\"red\"]:hover {\n  background: linear-gradient(135deg, #991b1b, #b91c1c);\n}\n\n/* ================= MODAL ================= */\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(2, 6, 23, 0.8);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: linear-gradient(\n    180deg,\n    #0f172a 0%,\n    #020617 100%\n  );\n  padding: 22px;\n  border-radius: 18px;\n  width: 420px;\n  max-width: 95%;\n  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.7);\n  border: 1px solid #1e293b;\n}\n\n.modal h2 {\n  margin-bottom: 16px;\n  font-size: 18px;\n}\n\n.modal label {\n  display: block;\n  margin-top: 12px;\n  margin-bottom: 6px;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #94a3b8;\n}\n\n.modal input,\n.modal select {\n  width: 100%;\n  padding: 9px;\n  border-radius: 8px;\n  border: 1px solid #334155;\n  background: #020617;\n  color: #e5e7eb;\n  font-size: 14px;\n}\n/* ================= SMALL INLINE PLACEHOLDER ================= */\n.no-schedule-placeholder {\n  padding: 10px 0 16px;\n  margin: 6px 0 18px;\n  text-align: center;\n  font-size: 13px;\n  color: #94a3b8;\n  opacity: 0.85;\n}\n\n.modal input:focus,\n.modal select:focus {\n  outline: none;\n  border-color: #3b82f6;\n}\n\n/* ================= MODAL ACTIONS ================= */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n/* ================= EMPTY STATE ================= */\n.empty {\n  opacity: 0.65;\n  font-style: italic;\n  padding: 10px 0;\n}\n\n/* ================= RESPONSIVE ================= */\n@media (max-width: 900px) {\n  .schedule-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
